import slugify from "slugify";

export function detectMobileOS(): 'Huawei' | 'Android' | 'Unknown' {
  const userAgent = navigator.userAgent || navigator.vendor;

  if (/huawei/i.test(userAgent)) {
    return 'Huawei';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  return 'Unknown';
}

export function toSeoSlug(text: string): string {
  return slugify(text, {
    lower: true,
    replacement: "-",
    strict: true,
    trim: true,
  });
}

// Use this ONLY for SEO purposes (canonical URLs, Open Graph, sitemaps, etc.)
// NOT for Next.js <Link> components - they need relative paths
export const getFullUrl = (path: string): string => {
  const baseUrl = (process.env.NEXT_PUBLIC_BASE_URL || 'https://www.CarSparesEzyFind.co.za').replace(/\/$/, '');
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${baseUrl}/${cleanPath}`;
};

// Use this for Next.js navigation - returns relative path
export const getRelativeUrl = (path: string): string => {
  // Ensure path starts with /
  return path.startsWith('/') ? path : `/${path}`;
};

export const isExternalUrl = (url: string): boolean => {
  return url.startsWith('http://') || url.startsWith('https://');
};